import { Component, Injectable, OnInit } from '@angular/core';
import { FileBase64 } from '../model/fileBase64';

@Injectable({
  providedIn: 'root',
})
export class Utils {

  isNullOrEmpty(value: any): boolean {
    return (
      value === null || value === undefined || value.toString().trim() === ''
    );
  }

  compararCampos(u1: any, u2: any): boolean {
    if (!u1 || !u2) return false;
    return u1.id === u2.id;
  }

  converterToIsoDate(date: string): string | null {
    if (!date) return null;
    const [data, tempo] = date.split("T")
    const [ano, mes, dia] = data.split("-");
    const [hora, minutos] = tempo.split(":");

    return new Date(Number(this.pad(parseInt(ano))), Number(this.pad(parseInt(mes) - 1)), Number(this.pad(parseInt(dia))), Number(this.pad(parseInt(hora) - 3)), Number(this.pad(parseInt(minutos))), Number(this.pad(parseInt("0")))).toISOString();
  }

  pad(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }

  getFileToBase64(file: File, tipoArquivo: string): Promise<FileBase64> {
    return this.fileToBase64(file).then((data) => {
      return {
        data: data,
        filename: file.name,
        contentType: file.type,
        documentType: tipoArquivo,
      } as FileBase64;
    });
  }

  /* MÉTODO UTILIZADO PARA CONVERTER FILE PARA BASE64 */
  fileToBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  /*
    @NOTE Utilize esse método para converter datas
    do tipo yyyy-MM-dd
  */
  formatarData(data: string) {
    const [ano, mes, dia] = data.split('-');
    
    var dataAtual = new Date(),
      hora = dataAtual.getHours(),
      minutos = dataAtual.getMinutes() <= 9 ? "0" + dataAtual.getMinutes() : dataAtual.getMinutes(),
      segundos = dataAtual.getSeconds() <= 9 ? "0" + dataAtual.getSeconds() : dataAtual.getSeconds();

      return new Date(Number(this.pad(parseInt(ano))), Number(this.pad(parseInt(mes) - 1)), Number(this.pad(parseInt(dia))), Number(this.pad(hora - 3)), Number(minutos), Number(this.pad(parseInt("0")))).toISOString();
  }

  formatarDateTimeParaData(date: string){
    const [data, tempo] = date.split("T")
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  formatarDateTimeParaNewDate(date: string){
    const [data, tempo] = date.split("T")
    const [ano, mes, dia] = data.split('-');
    return `${ano}-${mes}-${dia}`;
  }

}
